/* eslint-disable camelcase */
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { orderRoute } from 'modules/order/routes'

import { useLazyAuthInitTokenQuery } from '../api'
import { setAuthInfo } from '../helpers/token/token'
import { authRedirectRoute } from '../routes/AuthRedirectRoute'

export const AuthRedirect = () => {
  const navigate = useNavigate()
  const { auth_code, state } = authRedirectRoute.useSearch()
  const [authInitToken] = useLazyAuthInitTokenQuery()

  useEffect(() => {
    if (auth_code && state) {
      authInitToken({ code: auth_code, state }).then(({ data }) => {
        if (data) {
          setAuthInfo(data)
          localStorage.isLogged = true
          navigate(orderRoute)
        } else {
          navigate({ to: '/', replace: true })
        }
      })
    }
  }, [authInitToken, auth_code, navigate, state])

  return null
}
